export const ProcessCustomCategoriesEnum = {
  beforeCandidatePresentation: 'beforeCandidatePresentation',
  beforeProcessRecruitment: 'beforeProcessRecruitment',
  afterProcessRecruitment: 'afterProcessRecruitment'
}

export default {
  ProcessCustomCategoriesEnum
}
